import { Outlet, createRootRoute } from "@tanstack/react-router";
import Sidebar from "../components/Sidebar";
import Connect from "../components/Connect";
import Loading from "../components/Loading";
import { SignedIn, SignedOut, RedirectToSignIn } from "@clerk/clerk-react";
import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { useAuth, useUser } from "@clerk/clerk-react";
import { usePostHog } from "posthog-js/react";
import { useEffect } from "react";

const apiBaseUrl = import.meta.env.VITE_API_URL;

export const Route = createRootRoute({
  component: RootComponent,
  notFoundComponent: () => <div>404 Not Found</div>,
});

function RootComponent() {
  const { getToken } = useAuth();
  const { user, isSignedIn } = useUser();
  const posthog = usePostHog();

  // Identify user with PostHog when authenticated
  useEffect(() => {
    if (isSignedIn && user) {
      posthog.identify(user.id, {
        email: user.primaryEmailAddress?.emailAddress,
      });
    }
  }, [isSignedIn, user, posthog]);

  const { isPending, error, data } = useQuery({
    queryKey: ["channelInfo"],
    queryFn: async () => await checkMyChannel(),
  });

  const checkMyChannel = async () => {
    const token = await getToken();
    return axios.get(`${apiBaseUrl}/channel-info/`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  };

  if (isPending) {
    return (
      <>
        <Loading />
      </>
    );
  }

  return (
    <>
      <SignedIn>
        {data.data.channel ? (
          <Sidebar channel={data.data.channel}>
            <Outlet />
          </Sidebar>
        ) : (
          <>
            <Connect />
          </>
        )}
      </SignedIn>
      <SignedOut>
        <RedirectToSignIn />
      </SignedOut>
    </>
  );
}
